import {HttpCrudDataSource} from '../../core/data-source/http-crud.data-source';

export class StateProvinceCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/states/';
}
